/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetPaymentAccessToken Input Action
 */
export class GetPaymentAccessTokenInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `LARIPAYMENTACCESSTOKEN`;
    public getCacheObjectType = () => 'LARIPAYMENTACCESSTOKEN';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetPaymentAccessTokenData {
    token: string | undefined;
    success: boolean;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetPaymentAccessTokenInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getPaymentAPIToken(input: GetPaymentAccessTokenInput, ctx: Msdyn365.IActionContext): Promise<IGetPaymentAccessTokenData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetPaymentAccessTokenData[]>('/get/example/id/1', 'get');
    // const { szfPaymentDomain, szfPaymentAPIKey} = ctx.requestContext.app.config;
    const szfPaymentDomain = "https://api-gateway.sandbox.ngenius-payments.com";
    const szfPaymentAPIKey = "OGNjZWM1YmMtMWUzNi00NDkyLWFlNmItMGQ4NDQ5MDdkMTAxOmVmNDQ2NGYxLWI0MTctNDlkOC05ZmZmLTA1YzA1YWQ1Nzk0YQ==";
    try{
        const response = await Msdyn365.sendRequest<any>(`${szfPaymentDomain}/identity/auth/access-token`, "post", {}, {
            headers: {
                'Content-Type': 'application/vnd.ni-identity.v1+json',
                'authorization': `Basic ${szfPaymentAPIKey}`
            }
        });
        if(response && (response.status===200 || response.data)){
            return {
                token : response.data?.access_token!,
                success: true
            };
        }else{
            return { token : undefined, success: false };
        }
    }catch(err){
        console.log("Payment error",err)
        return { token: undefined, success: false };
    }
    
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetPaymentAccessTokenData>>getPaymentAPIToken,
    // TODO: Give your data action a unique id
    id: 'GetPaymentAccessToken',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});